<template>
  <div>
    <div v-if="true" class="pa-4">
      <div class="px-4 mb-6 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            :headline="`Chi tiết đối soát tháng ${$route.params.index}`"
            :link="[
              { text: 'Tài chính', href: '#' },
              { text: 'Đối soát theo tháng', href: '#' },
              { text: `Chi tiết đối soát tháng ${$route.params.index}` }
            ]"
          />
        </div>
        <ExportExcel />
      </div>
      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <StudentTable />
      </v-card>
    </div>
    <div v-else>
      <Page403 />
    </div>
  </div>
</template>
<script>
import Page403 from '@/views/Page403.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import StudentTable from '../../../modules/tuitionFee/report-month/detail-report-month/StudentTable.vue'
import ExportExcel from '@/modules/tuitionFee/report-month/detail-report-month/ExportExcel.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    Page403,
    Breadcrumbs,
    StudentTable,
    ExportExcel
  },
  created() {
    this.fetchPeriod(this.$route.params.id)
  },
  methods: {
    ...mapActions({
      fetchPeriod: 'tuitionFeePeriod/fetchPeriod'
    })
  }
}
</script>
<style scoped>
td {
  white-space: nowrap !important;
}
</style>
